// removed by extract-text-webpack-plugin
module.exports = {"container":"_1EALr","content":"_1hvTk","avatar-container":"_27DeN","avatar-image":"_1wuEq","location-pin":"_9Klm_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutFundraiser/AboutFundraiser.scss
// module id = ./src/components/AboutFundraiser/AboutFundraiser.scss
// module chunks = 4